import React from 'react';

const BillingProblemsMessage = () => (
  <>
    Por problemas de facturación comuníquese a{' '}
    <a href="mailto:servicio@epicland.com.mx">servicio@epicland.com.mx</a> o al
    teléfono <a href="tel:8150307332">8150307332</a>.
  </>
);

export default BillingProblemsMessage;
